<template>
  <div class="update">
    <el-form>
      <el-form-item label='版本名稱:'>
        <el-input
          type="text"
          v-model="versionInfo"
          @change="versionInfo = versionInfo.replace(/[^\d^\.]+/g,'')" />
        <!-- <el-input v-else  disabled  type="text" v-model="versionInfo" /> -->
      </el-form-item>
      <div class="versionSwitch">
        <el-radio-group v-model="versonCode">
          <el-radio :label="2">IOS配置</el-radio>
          <el-radio :label="1">Android配置</el-radio>
        </el-radio-group>
      </div> 
      <el-form-item label="版本图片:" class="picupload" v-if="imgAuth">
          <el-upload
            action=''
            :http-request='uploadRequest'
            :headers="{'Authorization': this.$cookie.get('auth')}"
            :with-credentials= "true"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :on-error ='$errorImage'
            :file-list="versonCode==2?versionImg:versionImgAndroid"
            :on-exceed="$handleExceed.bind(this, 5)"
            :before-upload="beforePicUpload.bind(this, 5)"
            :limit= 5
            accept=".jpg,.jpeg,.png"
            multiple
            name= 'mainPic'
            list-type="picture-card">
            <el-button size="small" type="primary">选择图片</el-button>
            <div slot="tip" class="el-upload__tip">需上傳完整750*1334的圖片,支持jpg/png格式(5MB以內)</div>
          </el-upload>
      </el-form-item>
    </el-form>
    <div class="bottomBtn">
      <div class="btn" @click="$router.go(-1)">返回</div>

      <div class="btn" @click="submitContent()">保存</div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import DiaMess from '@/components/dialog';
export default {
  props: ['type','id',],
  data () {
    return {
      versionInfo: '',
      versionImg: [],//主圖
      versionImgAndroid:[],
      require: true,  // 禁止用户连续点击，发出多次请求接口
      dialogVisible: false,
      imgAuth: null,
      versonCode:2
    }
  },
  created(){
    if (this.type==='edit') {
      this.getDetails();
    }
    this.roleType = localStorage.getItem('roleType')

    if ( this.roleType != null && this.roleType.indexOf('ROLE_GUEST')> -1) {

      this.imgAuth = true;

    } else {

      this.imgAuth = false;

    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    // 编辑获取版本介绍详情
    getDetails(){
      let param = {
        id: this.id,
        version: this.version,
      };
      this.$get(`/request/version/v2/getVersionIntro?id=${this.id}`, this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            this.versionInfo = res.data.version;
            if(res.data.versionCoverDtoList.length){
              res.data.versionCoverDtoList.map(item=>{
                if(item.platform == 1){
                  for(var i = 0; i < item.imgUrls.length; i++){
                    this.versionImgAndroid.push({name: 'img.jpg',url:item.imgUrls[i]})
                  }
                }else if(item.platform == 2){
                  for(var i = 0; i < item.imgUrls.length; i++){
                    this.versionImg.push({name: 'img.jpg',url:item.imgUrls[i]})
                  }
                }
              })
            }
          } else {
            this.$propMessage(res.message, 'error');
          }
        });
    },
    // 上传图片之前的回调函数
    beforePicUpload (num,file) {
      let _this = this;
      const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png');
      const isLt2M = file.size / 1024 / 1024 < Number(num);
      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage('上傳圖片只能是jpg或者png格式','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      };
      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage(`上傳圖片大小不能超過${num}MB!`,'error',function(){
          _this.dialogVisible = false;
        });

        return false;
      };
      // const isSize = new Promise(function (resolve, reject) {
      //   let width = 750
      //   let height = 1334
      //   let _URL = window.URL || window.webkitURL
      //   let img = new Image()
      //   img.onload = function () {
      //     let valid = img.width === width && img.height === height;
      //     valid ? resolve() : reject(new Error())
      //   }
      //   img.src = _URL.createObjectURL(file)
      // }).then(() => {
      //   return file
      // }, () => {
      //   _this.dialogVisible = true;
      //   _this.$propMessage('上傳圖片大小需為750*1334！','error',function(){
      //     _this.dialogVisible = false;
      //   });
      //   return Promise.reject(new Error())
      // })
      // const isWidth = new Promise((resolve, reject) => {
      //   let _URL = window.URL || window.webkitURL;
      //   let img = new Image();
      //   img.onload = function () {
      //     if (img.width > 3000 || file.size > 1024*1024*2) {
      //       _this.$imageConversion.compress(file, {
      //         quality: 0.3,
      //         width: 3000,
      //       }).then(res =>{
      //         resolve(res);
      //       })
      //     } else {
      //       resolve(file);
      //     }

      //   }
      //   img.src = _URL.createObjectURL(file);
      // })
      // return isJPG && isLt2M && isSize;
       return isJPG && isLt2M;
    },
    // 移除图片的回调函数
    handleRemove (file, fileList) {

      if (file && file.status==="success") {

        console.log('444')
        if(this.versonCode == 2){
          this.$deleteUidItem(file.uid, this.versionImg)
          if(this.versionImg.length < 5){
            document.getElementsByClassName('el-upload')[0].style.display = 'inline-block';
          }
        }else if (this.versonCode == 1){
          this.$deleteUidItem(file.uid, this.versionImgAndroid)
          if(this.versionImgAndroid.length < 5){
            document.getElementsByClassName('el-upload')[0].style.display = 'inline-block';
          }
        }
        
        
      } else {
        return(false);
      }

    },
    beforeRemove(file, fileList){

      if (file && file.status==="success") {
        return this.$confirm('是否刪除該版本圖片?刪除後將無法在客戶端展示', '提示信息', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          center: true,
          closeOnClickModal: false
        }).then(() => {
        }).catch(() => {
          reject(false);
        });
      }
    },
    uploadRequest(option){
      const file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), 'yyyy-MM-dd') // 当前时间
        const dateTime = self.$dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.$randomString(4)//  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        const fileWay = 'resource/photos/'
        const fileName = fileWay + date + '/' + dateTime + '_' + randomStr + extensionName // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then(client => {
          // 异步上传,返回数据
          // resolve({
          //   fileName: file.name,
          //   fileUrl: fileName // 图片路径
          // })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {headers:{'Cache-Control':'public'}})
          .then((val) => {
            if (val.res.statusCode === 200) {
            if(this.versonCode == 2){
              self.versionImg.push({name: 'img.jpg', url: self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic})
              //cdn预热
              self.$cdnFun(self.versionImg[0].url).then(res=>{
                console.log(res)
              })

              if(this.versionImg.length == 5){
                document.getElementsByClassName('el-upload')[0].style.display = 'none';
              }

              return val
            }else if (this.versonCode == 1){
              self.versionImgAndroid.push({name: 'img.jpg', url: self.$GLOBAL.picFileUrl + val.name + self.$GLOBAL.xwPic})
              //cdn预热
              self.$cdnFun(self.versionImgAndroid[0].url).then(res=>{
                console.log(res)
              })

              if(this.versionImgAndroid.length == 5){
                document.getElementsByClassName('el-upload')[0].style.display = 'none';
              }

              return val
            }

              
            } else {
              option.onError('上传失败1')
            }
          }, err => {
            console.log(err)
            option.onError('上传失败')
            reject(err)
          })
        })
      })
    },
    // 图片列表发生改变的回调函数
    // handleChange(file, fileList) {
    //   if (fileList.length > 1) {
    //     fileList.splice(0, 1);
    //   }
    // },
    // 提交内容
    submitContent(){
      let _this = this;
      if (_this.versionInfo === '' || _this.$getCaption(_this.versionInfo)) {
        _this.dialogVisible = true;
        _this.$propMessage('版本名稱不能為空或者含有非法字符','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      };
      if (_this.versionImg.length === 0 && _this.versionImgAndroid.length=== 0) {
        _this.dialogVisible = true;
        _this.$propMessage('版本圖片不能為空','error',function(){
          _this.dialogVisible = false;
        });

        return false;
      };

      _this.$confirm('是否發布該版本介紹?發佈後將應用商店展示該版本介紹', '提示信息', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          center: true,
        closeOnClickModal: false
        }).then(()=> {
          // 确认發佈的回调
          if(_this.require){
            _this.require=false
            // 新增版本介绍提交
            let coverRequestList = []
            if(this.versionImgAndroid.length){
              let imgUrls = []
              this.versionImgAndroid.map(item=>{
                imgUrls.push(item.url)
              })
              coverRequestList.push({
                platform:1,
                imgUrls
              })
            }
            if (this.versionImg.length){
              let imgUrls = []
              this.versionImg.map(item=>{
                imgUrls.push(item.url)
              })
              coverRequestList.push({
                platform:2,
                imgUrls
              })
            }
            let param = {
              version: _this.versionInfo,
              coverRequestList: coverRequestList
            }
            if (_this.type != 'add') {
              param = {
                ...param,
                id:this.id
              }
            }
            _this.$post(`/request/version/v2/versionIntro`, param, _this.$GLOBAL.jsonConfig)
            .then((res) => {
              _this.dialogVisible = true;
              if (res.code==='00000') {
                _this.$propMessage('操作成功', 'success',
                  function(){
                    _this.dialogVisible = false;
                    _this.$router.push('/updateIntList');
                  });

              } else {
                _this.$propMessage(res.message, 'error',
                  function(){
                    _this.dialogVisible = false;
                  });
              }
            });
          }
          setTimeout(() => {
            _this.require=true;
          },5000)
        }).catch(() => {
        });
    },
    versonChange(versonCode){
      this.versonCode = versonCode
    }
  },
  components: {
    DiaMess,
  }
};
</script>
<style lang="less" scoped>
  .versionSwitch{
    display: flex;
    margin-bottom: 0.24rem;
    /deep/ .el-radio__label{
      font-size: 14px;
      color: #606266;
      line-height: 40px;
    }
    .versonSwitchLeft{
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      cursor: pointer;
    }
    .versonSwitchRight{
      margin-left: 20px;
      font-size: 14px;
      color: #606266;
      line-height: 40px;
      cursor: pointer;
      
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/updateIntroduction.vue